import React from "react";
import LoaderSpinner from "react-loader-spinner";

const Loader = (props) => {
  return (
    <LoaderSpinner
      type="Oval"
      color={props.color || "#333"}
      height={props.height || 24}
      width={props.width || 24}
      {...props}
    />
  );
};
export default Loader;
